import Scene from "@/components/three/Scene";

export default function Home() {
  return (
    <main>
      <Scene />
    </main>
  );
}

